'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PassRecoveryStepTwo = undefined;

var _PassRecoveryStepTwo2 = require('./PassRecoveryStepTwo');

var _PassRecoveryStepTwo3 = _interopRequireDefault(_PassRecoveryStepTwo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.PassRecoveryStepTwo = _PassRecoveryStepTwo3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/PassRecovery/PassRecoveryStepTwo/index.js
// module id = 1728
// module chunks = 0